(function () {
  function updateBars() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const threshold = 5000; // $50.00 in cents
        document.querySelectorAll('[data-fsb]').forEach((bar) => {
          const current = cart.total_price;
          const remaining = threshold - current;
          let percent = (current / threshold) * 100;
          if (percent > 100) percent = 100;

          const fill = bar.querySelector('[data-fsb-fill]');
          const text = bar.querySelector('[data-fsb-text]');
          if (fill) fill.style.setProperty('--fsb-percent', percent + '%');

          bar.classList.toggle('free-shipping-bar--complete', remaining <= 0);

          if (text) {
            if (remaining > 0) {
              const money = formatMoney(remaining);
              text.innerHTML =
                "You're <strong>" + money +
                "</strong> away from <strong>free shipping!</strong>";
            } else {
              text.innerHTML =
                "🎉 You've unlocked <strong>free shipping!</strong>";
            }
          }
        });
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', updateBars);

  // Re-run whenever Dawn updates cart sections
  document.addEventListener('cart:refresh', updateBars);

  // Patch fetch to catch Dawn's cart-update calls
  const origFetch = window.fetch;
  window.fetch = function () {
    return origFetch.apply(this, arguments).then((res) => {
      const url = arguments[0];
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        setTimeout(updateBars, 50);
      }
      return res;
    });
  };
})();